<template>
  <div class="yht-backStage-ztyj">
    <div class="yht-backStage-ztyj-content">
      <div class="flex mb20">
        <div
          v-for="item in typeList"
          :key="item.id"
          class="yht-backStage-ztyj_typeBtn cp"
          :class="{'active' : item.id === typeSelect.id}"
          @click="clickType(item)"
          v-text="item.name"></div>
      </div>
      <div class="flex mb20">
        <div class="yht-backStage-ztyj-content_btn mr15 cp" @click="BatchOnOrOff('0')">批量下线</div>
        <div class="yht-backStage-ztyj-content_btn cp" @click="BatchOnOrOff('1')">批量上线</div>
      </div>
      <div class="yht-backStage-ztyj-content_search">
        <el-input class="ztyj-input" placeholder="文献检索···" v-model="keyWord" @keyup.enter.native="handleSearch"></el-input>
        <div class="yht-backStage-ztyj-content_search_icon cp" @click="handleSearch"></div>
      </div>
      <div class="yht-backStage-ztyj_table ">
        <el-table
          v-loading="loading"
          ref="table"
          height="calc(100% - 50px)"
          tooltip-effect="light"
          :row-key="(row) => {return row.name}"
          @selection-change="handleSelectionChange"
          :data="ztyjList">
          <el-table-column label="" width="20" key="1"></el-table-column>
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="序号" width="80" type="index" key="3">
            <span slot-scope="scope">{{ scope.$index + (pageNo - 1) * pageSize + 1 }}</span>
          </el-table-column>
          <el-table-column prop="name" label="名称" width="300" key="4">
            <span slot-scope="scope" :title="scope.row.name">{{scope.row.name}}</span>
          </el-table-column>
          <el-table-column prop="author" label="作者" key="5">
            <span slot-scope="scope" :title="scope.row.author">{{scope.row.author}}</span>
          </el-table-column>
          <el-table-column prop="source" label="来源" key="6">
            <span slot-scope="scope" :title="scope.row.source">{{scope.row.source}}</span>
          </el-table-column>
          <el-table-column prop="publicationTime" width="120" label="发表时间" key="7">
            <span slot-scope="scope" :title="scope.row.publicationTime">{{scope.row.publicationTime}}</span>
          </el-table-column>
          <el-table-column prop="sourceDatabase" label="来源数据库" key="8">
            <span slot-scope="scope" :title="scope.row.sourceDatabase">{{scope.row.sourceDatabase}}</span>
          </el-table-column>
          <el-table-column prop="download" label="下载" key="9">
            <span slot-scope="scope" :title="scope.row.download">{{scope.row.download}}</span>
          </el-table-column>
          <el-table-column prop="isOnlineStr" label="全部状态" key="10">
            <template slot-scope="scope">
              <span class="yht-backStage-ztyj_table_status" :class="{'online' : scope.row.isonline === '线上', 'offline' : scope.row.isonline === '下线'}" :title="scope.row.isonline">{{scope.row.isonline }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" key="11">
            <template slot-scope="scope">
              <div class="yht-backStage-ztyj_table_operate">
                <div class="yht-backStage-ztyj_table_view cp" :title="'预览'" @click="viewDetail(scope.row)"></div>
                <div
                  class="yht-backStage-ztyj_table_line cp"
                  :class="{'offline' : scope.row.isonline === '线上'}"
                  :title="scope.row.isonline === '线上' ? '下线' : '上线'"
                  @click="singleOnOffLine(scope.row)"></div>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <span class="mt10" style="display:block;font-size: 12px;color: #666666;">暂无查询数据</span>
          </template>
        </el-table>
        <!-- 页码 -->
        <div class="yht-backStage-ztyj_page yht-backStage-page">
          <el-pagination
            v-show="total>15 && !loading"
            background
            layout="total, prev, pager, next"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            @current-change="changePage">
          </el-pagination>
        </div>
      </div>
      <!--上下线确认-->
      <div class="yht-backStage_dialog yht-backStage_dialog_ztyj">
        <el-dialog :title="checkStatus === '0' ? '下线确认' : '上线确认'" width="400px" :visible="showBatch"
                   :close-on-click-modal="false"
                   :before-close="handleBatchCancel">
          <div v-show="BatchOrSingle === 'batch'" class="te-center mt15 yht-backStage_dialog_content"> 确定<span v-text="checkStatus === '0' ? '下线' : '上线'"></span>所选精品文献？</div>
          <div v-show="BatchOrSingle === 'single'" class="te-center mt15">
            <div v-text="selectObj.name"></div>
            <div class="mt10">
              将在专题研究-<span v-text="typeSelect.name"></span>展示模块<span v-text="checkStatus === '0' ? '下线' : '上线'"></span>
            </div>
          </div>
          <div class="yht-backStage_dialog_btnBox mt30">
            <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnConfirm" @click="handleConfirm">确认</div>
            <div class="yht-backStage_dialog_btn yht-backStage_dialog_btnCancel" @click="handleBatchCancel">取消</div>
          </div>
        </el-dialog>
        <el-dialog :title="selectObj.name" width="620px" :visible="showDetail"
                   :close-on-click-modal="false"
                   :before-close="handleDetailCancel">
          <div class="yht-backStage_dialog_name mt30" v-text="selectObj.name"></div>
          <div class="flex mt30 font-s16" v-if="selectObj && selectObj.author">
            <div class="yht-backStage_dialog_info_left">作者：</div>
            <div class="yht-backStage_dialog_info_right" v-text="selectObj.author"></div>
          </div>
          <div class="flex mt30 font-s16" v-if="selectObj && selectObj.source">
            <div class="yht-backStage_dialog_info_left">来源：</div>
            <div class="yht-backStage_dialog_info_right" v-text="selectObj.source"></div>
          </div>
          <div class="flex mt30 font-s16" v-if="selectObj && selectObj.abstracts">
            <div class="yht-backStage_dialog_info_left">摘要：</div>
            <div class="yht-backStage_dialog_info_right text-ellipsis-4" :title="selectObj.abstracts" v-text="selectObj.abstracts"></div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ztyj',
  data () {
    return {
      loading: false,
      typeList: [
        {
          name: '红色文化研究',
          id: '0051090501'
        }, {
          name: '雨花英烈研究',
          id: '0051090503'
        }, {
          name: '综合管理研究',
          id: '0051090505'
        }
      ],
      typeSelect: {
        name: '红色文化研究',
        id: '0051090501'
      },
      // 搜索框输入内容
      keyWord: '',
      // 精品文物表格list
      ztyjList: [],
      // 搜索参数
      searchText: '',
      // 页数
      pageNo: 1,
      // 条数
      pageSize: 15,
      // 总数
      total: 0,
      // 上线还是下线
      checkStatus: '',
      nameList: [],
      // 上下线确认框显示
      showBatch: false,
      // 批量上下线还是单独上下线
      BatchOrSingle: '',
      // 选中的文物
      selectObj: { name: '' },
      // 文物图片弹框显示
      showDetail: false,
      // 文物图片list
      urlList: [{ imgUrl: '' }],
      pageImgNo: 1,
      pageImgSize: 1,
      totalImg: 0
    }
  },
  props: {
  },
  mounted () {
    this.getListSpecial()
  },
  methods: {
    // 点击分类
    clickType (param) {
      this.typeSelect = param
      this.pageNo = 1
      this.keyWord = ''
      this.searchText = ''
      this.$refs.table.clearSelection()
      this.getListSpecial()
    },

    // 获取专题研究列表
    getListSpecial () {
      const self = this
      self.loading = true
      const data = {
        selectBy: this.searchText,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        specialType: this.typeSelect.id
      }
      axios.post('/yuhuamenhu/special/listSpecial', data).then(json => {
        if (json.data.code === 200) {
          self.ztyjList = json.data.data.rows
          self.total = json.data.data.totalRows
        } else {
          self.$message.warning(json.data.message)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loading = false
      })
    },

    // 批量选择
    handleSelectionChange (val) {
      this.nameList = val.map(m => {
        return m.name
      })
    },

    // 检索功能
    handleSearch () {
      this.searchText = this.keyWord
      this.pageNo = 1
      this.getListSpecial()
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getListSpecial()
    },

    // 点击批量上下线
    BatchOnOrOff (param) {
      if (this.nameList.length === 0) {
        this.$message.warning('请先选择要上下线的文献！')
        return
      }
      this.checkStatus = param
      this.BatchOrSingle = 'batch'
      this.showBatch = true
    },

    // 关闭上下线弹窗
    handleBatchCancel () {
      this.nameList = []
      this.$refs.table.clearSelection()
      this.showBatch = false
    },

    // 点击单独上下线
    singleOnOffLine (param) {
      this.selectObj = param
      this.nameList = [param.name]
      this.checkStatus = param.isonline === '下线' ? '1' : '0'
      this.BatchOrSingle = 'single'
      this.showBatch = true
    },

    // 专题研究上下线
    handleConfirm () {
      const self = this
      const names = this.nameList.join(',')
      const data = {
        checkStatus: this.checkStatus,
        names: names
      }
      axios.post('/yuhuamenhu/special/updateIsOnline', data).then(json => {
        if (json.data.code === 200) {
          this.handleBatchCancel()
          this.getListSpecial()
          self.$message.success(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 查看详情
    viewDetail (param) {
      this.selectObj = param
      this.showDetail = true
    },
    // 关闭详情弹框
    handleDetailCancel () {
      this.showDetail = false
    }
  }
}
</script>

<style>
  .yht-backStage-ztyj {
    padding-bottom: 40px;
    width: 100%;
    height: 100%;
  }

  .yht-backStage-ztyj-content {
    position: relative;
    padding: 30px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0 4px 50px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-ztyj_typeBtn {
    margin-right: 34px;
    width: 126px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    border: 1px solid #8B1D13;
    color: #8B1D13;
    text-align: center;
  }

  .yht-backStage-ztyj_typeBtn:hover,
  .yht-backStage-ztyj_typeBtn.active {
    color: #fff;
    background-color: #8B1D13;
  }

  .yht-backStage-ztyj-content_btn {
    width: 98px;
    height: 36px;
    line-height: 36px;
    color: #666666;
    text-align: center;
    border-radius: 4px;
    background: #FFFFFF;
    border: 1px solid #666666;
  }

  .yht-backStage-ztyj-content_btn:hover {
    color: #8B1D13;
    border-color: #8B1D13;
  }

  .yht-backStage-ztyj-content_search {
    position: absolute;
    top: 72px;
    right: 30px;
  }

  .ztyj-input{
    width: 360px;
    height: 38px;
    border-radius: 4px;
  }

  .ztyj-input .el-input__inner,
  .ztyj-input .el-input.is-active .el-input__inner,
  .ztyj-input .el-input__inner:focus,
  .ztyj-input .el-input__inner:hover{border-color: #ccc;}

  .ztyj-input >.el-input__inner {
    padding-right: 45px;
  }

  .yht-backStage-ztyj-content_search_icon {
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -15px;
    width: 30px;
    height: 31px;
    background: url("../images/search.png");
    background-size: 100% 100%;
  }

  .yht-backStage-ztyj_table {
    width: 100%;
    height: calc(100% - 112px);
  }

  .yht-backStage-ztyj_page {
    position: relative;
    margin-top: 10px;
    width: 100%;
    height: 50px;
  }

  .yht-backStage-ztyj_page .el-pagination {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .yht-backStage-ztyj_table_status {
    position: relative;
    padding-left: 20px;
  }

  .yht-backStage-ztyj_table_status::before {
    content: '';
    position: absolute;
    top: 5px;
    left: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .yht-backStage-ztyj_table_status.online::before {
    background: #60A93F;
  }

  .yht-backStage-ztyj_table_status.offline::before {
    background: #C7C7C7;
  }

  .yht-backStage-ztyj_table_operate {
    display: flex;
  }

  .yht-backStage-ztyj_table_view {
    margin-right: 28px;
    width: 15px;
    height: 16px;
    background: url("../images/ztyj_detail.png");
    background-size: 100% 100%;
  }

  .yht-backStage-ztyj_table_line {
    width: 15px;
    height: 17px;
    background: url("../images/online.png");
    background-size: 100% 100%;
  }

  .yht-backStage-ztyj_table_line.offline {
    background: url("../images/offline.png");
    background-size: 100% 100%;
  }

  .yht-backStage_dialog_name {
    font-weight: bold;
    font-size: 16px;
    color: #222;
  }

  .yht-backStage_dialog_info_left {
    font-weight: bold;
    color: #222;
  }

  .yht-backStage_dialog_info_right {
    flex: 1;
  }

  .text-ellipsis-4 {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
  }
</style>
